import { Card, CardContent, CardHeader } from './ui/card';
import { Skeleton } from './ui/skeleton';

const rows = [0, 1, 2, 3, 4];

/** Placeholder shown in the report area while a report is being generated. */
export function ReportLoading({ sections = 3 }) {
  return (
    <div className="space-y-8 no-print" aria-busy="true" aria-live="polite">
      <div className="flex items-center justify-center gap-3 text-muted-foreground">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
        <span className="text-sm font-medium">Generating report…</span>
      </div>

      {Array.from({ length: sections }).map((_, section) => (
        <Card key={section}>
          <CardHeader className="space-y-2">
            <Skeleton className="h-6 w-56" />
            <Skeleton className="h-4 w-72" />
          </CardHeader>
          <CardContent className="space-y-3">
            {rows.map((row) => (
              <div key={row} className="flex items-center gap-4">
                <Skeleton className="h-5 flex-1" />
                <Skeleton className="h-5 w-24" />
                <Skeleton className="h-5 w-24" />
                <Skeleton className="h-5 w-24" />
              </div>
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export default ReportLoading;
